import { Alert, List, ListItem, ListItemText, Text } from '@shared/components';

import { TIME_POSTPONEMENT_CONDITIONS } from '../../constants';

interface TimePostponementAlertProps {
  errorMessage?: string;
}

export default function TimePostponementAlert(props: Readonly<TimePostponementAlertProps>) {
  const { errorMessage } = props;

  if (errorMessage) {
    return (
      <Alert
        severity='error'
        sx={{
          '& .MuiAlert-message': {
            overflow: 'visible',
          },
        }}
      >
        <Text variant='body1'>{errorMessage}</Text>
      </Alert>
    );
  }

  return (
    <Alert severity='info' sx={{ alignItems: 'flex-start' }}>
      <Text variant='body1'>เงื่อนไขการเลื่อนเวลาสอบ:</Text>
      <List
        sx={(theme) => ({
          p: 0,
          pl: theme.spacing(6),
          listStyleType: 'disc',
        })}
      >
        {TIME_POSTPONEMENT_CONDITIONS.map((condition) => (
          <ListItem key={condition} sx={{ p: 0, display: 'list-item' }}>
            <ListItemText primary={condition} sx={{ my: 0 }} />
          </ListItem>
        ))}
      </List>
    </Alert>
  );
}
